import { LuSearch } from "react-icons/lu";

export const CardGridHeaderSearch = ({ list, setList, placeholder }) => {

    const filterListBySearch = (search) => {
        const newResultList = [];
        for (let a of  list) {
            const searchValue = search?.target?.value?.toLowerCase();
            const nameMatches = a?.["name"]?.toLowerCase()?.includes(searchValue);
            const planDetailsNameMatches = a?.["planDetails"]?.["name"]?.toLowerCase()?.includes(searchValue);
            const planIdMatches = a?.["planId"]?.toLowerCase()?.includes(searchValue);
            var  stageMatches = false;


            if (stageMatches || nameMatches || planDetailsNameMatches || planIdMatches) {
                a.hidden = false;
                newResultList?.push(a);
            } else {
                a.hidden = true;
                newResultList?.push(a);
            }
        }
        setList(newResultList);
    };


    return (
        <span className={'h-10 w-full rounded bg-white  placeholder-gray-600 items-center gap-x-1.5  flex px-3 hover:ring-gray-900 border-2 ring-0 border-gray-500 hover:border-gray-600 text-sm text-gray-900 mr-2'}>
            <LuSearch className={"h-5 w-5"} />
            <input
                autoComplete='off'
                type='listSsearch'
                name='listSsearch'
                id='listSsearch'
                onChange={(e) => filterListBySearch(e)}
                className=' h-full ring-0 outline-0 border-0 py-2.5 w-full '
                placeholder={placeholder}
            />
        </span>
    );
};
